fragment VisitorIqFilterSettingsFragment on FilterSettingsPayload {
    mcfxIndustries {
        industry {
            id
            name
        }
        isBlocked
    }
    contactInformationList {
        contactInformation {
            id
            name
        }
        isBlocked
    }
    jobFieldList {
        jobField {
            id
            name
        }
        isBlocked
    }
    managementLevelList {
        managementLevel {
            id
            name
        }
        isBlocked
    }
    urlBlocklist
}
